import RankedAPI from "@api/lol/Ranked.api";
import ButtonVariants from "@core-components/button/ButtonVariants";
import Emoji from "@core-components/emoji/Emoji";
import LolRegionSelectorBanner from "@core-components/regionSelector/banner/LolRegionSelectorBanner";
import SSHeadline from "@core-components/title/SSHeadline";
import SSLoLGradientText from "@core-components/title/components/SSLoLGradientText";
import SSWhiteText from "@core-components/title/components/SSWhiteText";
import EPublicRoutes from "@core-types/routes.enum";
import useAppTranslation from "@hooks/language/useAppTranslation";
import { useAppRegion } from "@hooks/region/useAppRegion";
import { Group, Stack } from "@mantine/core";
import { SmurfRankedList } from "@modules/ranked/components/SmurfRankedList";
import type { IRankedSmurfCardItem } from "@modules/ranked/models/IRankedSmurf.models";
import { useCallback, useEffect, useState } from "react";
import { Trans } from "react-i18next";

export const RankedWidget: React.FC = () => {
  const { t } = useAppTranslation("components.rankedWidget");
  const [rankedAccounts, setRankedAccounts] = useState<IRankedSmurfCardItem[]>(
    [],
  );
  const { regionUrlBuilder } = useAppRegion();

  const loadData = useCallback(() => {
    RankedAPI.getWidgetAccounts().then((res) => {
      setRankedAccounts(res.data);
    });
  }, []);

  useEffect(() => {
    loadData();
  }, [loadData]);

  return (
    <Stack className="w-full" gap={0}>
      <Group
        className="w-full px-3 xs:px-10 py-0 xs:py-5"
        justify="space-between"
        wrap="nowrap"
      >
        <SSHeadline props={{ title: { fz: 26 } }}>
          <Emoji.Trophy size={26} />
          <Trans t={t} i18nKey="title">
            <SSWhiteText>COMPTES</SSWhiteText>
            <SSLoLGradientText>CLASSÉS</SSLoLGradientText>
          </Trans>
        </SSHeadline>
        <ButtonVariants.SeeMore
          href={regionUrlBuilder(EPublicRoutes.SMURFS_RANKED)}
          title={t("viewAll")}
        />
      </Group>
      <LolRegionSelectorBanner className="mb-6" onRegionChange={loadData} />
      <div className="max-w-full">
        <SmurfRankedList accounts={rankedAccounts} />
      </div>
    </Stack>
  );
};
